import React from "react";
import { ShapeLogo } from "../ShapeLogo";
import { styled } from "@mui/material";

export const PoweredByShape: React.FC<{ width?: number; alignTo?: string }> = ({
  width,
  alignTo = "end",
}) => {
  return (
    <StyledStrong sx={{ width: width, alignItems: alignTo, svg: { alignSelf: alignTo } }}>
      <span>powered by</span> <ShapeLogo height="14px" width="53px" />
    </StyledStrong>
  );
};
const StyledStrong = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: "10px",
  marginLeft: "16px",
  display: "grid",
  gridTemplateColumns: "auto auto",
  gap: "6px",
  fontWeight: 300,
  svg: { marginBottom: "1px" },
  color: theme.tokens.colors.gray[7],
  height: "16px",
  ">span": { lineHeight: "14px" },
}));
